var map = {
	"./E1栋大堂客梯厅三.mp4": 5571,
	"./E1负一楼后门过道一.mp4": 9318,
	"./E2大堂西.mp4": 9806,
	"./E2天台东.mp4": 6243,
	"./E栋广场北面通道.mp4": 6735,
	"./二期负二E区02通道.mp4": 3086,
	"./二期负二E区07拐角通道.mp4": 1488,
	"./二期负二停车位292.mp4": 5687,
	"./南北围栏5.mp4": 6233,
	"./旋转楼梯球机.mp4": 9489
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 8180;